import {InjectionToken, Provider} from '@angular/core';
export let EMPLOYEE_PROPERTIES_BITMASK_SERVICE: any = new InjectionToken<EmployeePropertiesBitmaskService>('tt.employeePropertiesBitmaskService');

export interface EmployeePropertiesBitmaskValues {
	timetrackerAdmin: number;
	hideMissingWorkingDaysNotification: number;
	hideOnCallNotification: number;
	hideDaysOffNotification: number;
	hideWorkingTimeNotification: number;
}

export interface EmployeePropertiesBitmaskService {
	bitmask: EmployeePropertiesBitmaskValues;
	hasProperty(property: string, employeeBitmask: number): boolean;
	enableProperty(property: string, employeeBitmask: number): number;
	disableProperty(property: string, employeeBitmask: number): number;
}

export function employeePropertiesBitmaskServiceFactory(i: any): any {
	return i.get('employeePropertiesBitmaskService');
}

export const employeePropertiesBitmaskServiceProvider: Provider = {
	provide: EMPLOYEE_PROPERTIES_BITMASK_SERVICE,
	useFactory: employeePropertiesBitmaskServiceFactory,
	deps: ['$injector']
};



// WEBPACK FOOTER //
// ./src/app/shared/upgrade/employee-properties-bitmask.service.ts